import { useEffect, useState } from 'react';
import { bool, string } from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import ProgressNavNode from './ProgressNavNode';
import { nmfNavigation } from './progressNavNodeData';
import * as styles from './ProgressNav.module.css';

const NewMemberNav = ({ step, hideCustomizeNode = false, hideBoostNode = true }) => {
  const nodesToHide = [];
  hideCustomizeNode && nodesToHide.push('customize');
  hideBoostNode && nodesToHide.push('boost');
  const nmfNavigationData = nmfNavigation.filter((node) => !nodesToHide.includes(node.key));

  const [currentNode, setCurrentNode] = useState(-1);
  const isDesktop = useMediaQuery({
    query: '(min-width: 992px)',
  });
  const viewSize = isDesktop ? 'large' : 'small';

  useEffect(() => {
    const getCurrentNode = () => {
      const index = nmfNavigationData.findIndex((x) => x.key.toLowerCase() === step.toLowerCase());
      setCurrentNode(index);
    };

    getCurrentNode();
  }, [step, nmfNavigationData]);

  return (
    <div className={`${styles.navigation} ${styles[viewSize]}`}>
      {nmfNavigationData.map((node, index) => {
        const selected = index <= currentNode;
        return (
          <ProgressNavNode
            key={node.title}
            number={`${index + 1}`}
            item={node}
            selected={selected}
          />
        );
      })}
    </div>
  );
};

NewMemberNav.propTypes = {
  step: string.isRequired,
  hideCustomizeNode: bool,
  hideBoostNode: bool,
};

export default NewMemberNav;
